/* Copyright (c) 2026. Amazon.com, Inc. or its affiliates. All rights reserved. */

export const libraryPages = {
    LatestPodcastsPage: () => import('@/library/LatestPodcastsPage'),
    Library: () => import('@/library/Library'),
    MyAudiobooksPage: () => import('@/library/MyAudiobooksPage'),
    MyLibraryListPage: () => import('@/library/MyLibraryListPage'),
    MyPlaylistsPage: () => import('@/library/MyPlaylistsPage'),
    MyPodcastPlaylistPage: () => import('@/library/MyPodcastPlaylistPage'),
    SongHistoryPage: () => import('@/library/SongHistoryPage'),
}
